module.exports = window.__federationLoadRemote("moduleClient");